import { Card } from '@/shared/ui/card';
import type { MgmPublicRules } from '../../model/types';

function formatDate(value: string | null): string {
  return value ? new Date(value).toLocaleDateString('pt-BR') : '';
}

/** Passo a passo + as letras miúdas que vêm das regras (sem texto solto inventado). */
export function HowItWorks({ rules }: { rules: MgmPublicRules }) {
  const needsPurchase =
    (rules.referrer.enabled && rules.referrer.trigger === 'first_purchase') ||
    (rules.referred.enabled && rules.referred.trigger === 'first_purchase');
  const steps = [
    { title: 'Compartilhe seu link', text: 'Mande pelo WhatsApp, redes sociais ou mostre o QR Code.' },
    { title: 'Seu amigo se cadastra', text: 'Ele entra no programa pelo seu link — é assim que sabemos que foi você.' },
    needsPurchase
      ? { title: 'Ele faz a primeira compra', text: 'Com a compra confirmada, a recompensa cai no seu cartão.' }
      : { title: 'Pronto!', text: 'A recompensa cai no seu cartão logo depois do cadastro.' },
  ];

  const notes: string[] = [];
  if (needsPurchase && rules.minAmount) {
    notes.push(`Vale a primeira compra a partir de ${rules.minAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}.`);
  }
  if (needsPurchase && rules.withinDays) notes.push(`A primeira compra precisa acontecer em até ${rules.withinDays} dias do cadastro.`);
  notes.push('Cada amigo conta uma vez, e só se ainda não participava do programa.');
  notes.push(
    rules.endsAt
      ? `Campanha válida de ${formatDate(rules.startsAt)} a ${formatDate(rules.endsAt)}.`
      : `Campanha válida a partir de ${formatDate(rules.startsAt)}.`,
  );

  return (
    <Card className="p-5">
      <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Como funciona</p>
      <ol className="mt-3 space-y-4">
        {steps.map((step, i) => (
          <li key={step.title} className="flex gap-3">
            <span className="mgm-accent-bg grid size-7 shrink-0 place-items-center rounded-full text-sm font-bold">{i + 1}</span>
            <div>
              <p className="text-sm font-medium">{step.title}</p>
              <p className="text-sm text-muted-foreground">{step.text}</p>
            </div>
          </li>
        ))}
      </ol>
      <ul className="mt-4 space-y-1 border-t border-border/60 pt-3 text-xs text-muted-foreground">
        {notes.map((n) => (
          <li key={n}>• {n}</li>
        ))}
      </ul>
    </Card>
  );
}
